var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyordersNextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.62,
    height: 24,
    viewBox: "0 0 158.62 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173670",
    "data-name": "Group 173670",
    transform: "translate(567 1587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IntelReg",
    transform: "translate(-567 -1587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,29.41V18.847H5.406V29.41Z",
    transform: "translate(-0.001 -5.422)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M26.023,7.618V26.2H31.43V7.618Z",
    transform: "translate(-7.441 -2.211)",
    fill: "#ed0677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M26.023,5.451H31.43V.047H26.023Z",
    transform: "translate(-7.441 -0.047)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M10.474,11.282H0v5.406H10.474Z",
    transform: "translate(-0.001 -3.259)",
    fill: "#00c0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M18.582.05H0v5.4H18.583Z",
    transform: "translate(-0.001 -0.047)",
    fill: "#00c0f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M14.664,18.85V29.41h5.408V18.847Z",
    transform: "translate(-4.193 -5.422)",
    fill: "#ed0677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M14.664,16.687h5.408V11.282H14.664Z",
    transform: "translate(-4.193 -3.259)",
    fill: "#034ea2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M56.707,3.879H43.139v6.166H55.162v3.8H43.141v6.405H56.878v3.8H38.963V.076H56.707Z",
    transform: "translate(-11.141 -0.055)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M85.068,24.056l-6.3-9.077-6.337,9.077H67.6l8.734-12.194L67.942.079h4.967l5.96,8.6,5.995-8.6h4.829L81.339,11.793l8.7,12.262Z",
    transform: "translate(-19.329 -0.056)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M113.606,24.056h-4.247V3.983h-7.6V.078h19.453V3.983h-7.6Z",
    transform: "translate(-29.095 -0.056)",
    fill: "#034ea2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M136.338,2.344V.807l-.616,1.172h-.271L134.838.823V2.344h-.376V.05h.329l.795,1.526.8-1.526h.321V2.344Zm-3.4,0V.393H132.2V.05h1.911V.393h-.753V2.344Z",
    transform: "translate(-37.799 -0.047)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21304",
    "data-name": "Path 21304",
    d: "M1.022-.735v-6.33H2.293V-6.04a2.07,2.07,0,0,1,.791-.843,2.28,2.28,0,0,1,1.18-.3A1.786,1.786,0,0,1,6.146-5.91,2.235,2.235,0,0,1,7-6.844a2.408,2.408,0,0,1,1.271-.337q2.127,0,2.127,2.542v3.9H9.09V-4.574a2,2,0,0,0-.279-1.18A1.063,1.063,0,0,0,7.9-6.131a1.39,1.39,0,0,0-1.128.5,2.056,2.056,0,0,0-.415,1.355V-.735H5.043V-4.574a2.032,2.032,0,0,0-.272-1.18,1.045,1.045,0,0,0-.908-.376,1.371,1.371,0,0,0-1.122.5,2.078,2.078,0,0,0-.409,1.355V-.735ZM12.813,1.6,13.941-.9,11.295-7.065h1.4l1.946,4.812,1.972-4.812h1.349L14.188,1.6ZM23.021-.618a4.321,4.321,0,0,1-2.27-.577A3.864,3.864,0,0,1,19.266-2.83a5.519,5.519,0,0,1-.525-2.484,5.509,5.509,0,0,1,.525-2.49,3.83,3.83,0,0,1,1.485-1.621A4.36,4.36,0,0,1,23.021-10a4.368,4.368,0,0,1,2.263.571A3.817,3.817,0,0,1,26.776-7.8,5.478,5.478,0,0,1,27.3-5.326a5.55,5.55,0,0,1-.525,2.5A3.851,3.851,0,0,1,25.284-1.2,4.33,4.33,0,0,1,23.021-.618Zm0-1.167a2.588,2.588,0,0,0,2.121-.927,4,4,0,0,0,.759-2.6,4,4,0,0,0-.752-2.594,2.591,2.591,0,0,0-2.127-.921,2.6,2.6,0,0,0-2.121.921,3.973,3.973,0,0,0-.759,2.594,4,4,0,0,0,.759,2.6A2.588,2.588,0,0,0,23.021-1.785ZM28.961-.735v-6.33h1.271v1.128a2.219,2.219,0,0,1,2.049-1.258l.428-.026L32.8-6.1l-.791.078A1.648,1.648,0,0,0,30.284-4.25V-.735Zm7.16.117a2.683,2.683,0,0,1-1.459-.4,2.632,2.632,0,0,1-.979-1.135,4.055,4.055,0,0,1-.35-1.751,4.012,4.012,0,0,1,.35-1.745,2.7,2.7,0,0,1,.973-1.135,2.642,2.642,0,0,1,1.466-.4,2.564,2.564,0,0,1,1.271.311,2,2,0,0,1,.83.843V-9.879h1.31V-.735H38.249v-1.1a2.015,2.015,0,0,1-.837.895A2.543,2.543,0,0,1,36.121-.618Zm.337-1.012a1.615,1.615,0,0,0,1.3-.584A2.547,2.547,0,0,0,38.249-3.9a2.52,2.52,0,0,0-.493-1.68,1.623,1.623,0,0,0-1.3-.577,1.637,1.637,0,0,0-1.31.577,2.52,2.52,0,0,0-.493,1.68,2.547,2.547,0,0,0,.493,1.686A1.629,1.629,0,0,0,36.459-1.63ZM44.345-.618a3.355,3.355,0,0,1-2.452-.876A3.194,3.194,0,0,1,41-3.887a3.613,3.613,0,0,1,.4-1.719,2.9,2.9,0,0,1,1.1-1.161A3.1,3.1,0,0,1,44.1-7.181a2.633,2.633,0,0,1,2.062.837,3.319,3.319,0,0,1,.752,2.3V-3.6H42.27A1.878,1.878,0,0,0,44.358-1.63a3.481,3.481,0,0,0,1.07-.169,2.96,2.96,0,0,0,.992-.558l.389.908a3,3,0,0,1-1.1.61A4.358,4.358,0,0,1,44.345-.618ZM44.15-6.26a1.7,1.7,0,0,0-1.3.506,2.308,2.308,0,0,0-.584,1.349h3.541a2.155,2.155,0,0,0-.467-1.368A1.506,1.506,0,0,0,44.15-6.26ZM48.34-.735v-6.33h1.271v1.128a2.219,2.219,0,0,1,2.049-1.258l.428-.026L52.179-6.1l-.791.078A1.648,1.648,0,0,0,49.663-4.25V-.735Zm6.991.117a5.063,5.063,0,0,1-1.453-.2,3.289,3.289,0,0,1-1.128-.564l.376-.882a3.82,3.82,0,0,0,1.057.519,3.849,3.849,0,0,0,1.161.182,1.8,1.8,0,0,0,1.038-.246.77.77,0,0,0,.35-.662A.637.637,0,0,0,56.5-3a1.714,1.714,0,0,0-.7-.292l-1.232-.246q-1.634-.337-1.634-1.686a1.689,1.689,0,0,1,.713-1.427,3.047,3.047,0,0,1,1.868-.532,4.094,4.094,0,0,1,1.265.195,2.541,2.541,0,0,1,1.005.584l-.376.882a2.793,2.793,0,0,0-.895-.519,2.942,2.942,0,0,0-1-.182,1.74,1.74,0,0,0-1.025.253.8.8,0,0,0-.35.681q0,.649.856.83l1.232.246A2.6,2.6,0,0,1,57.5-3.64a1.412,1.412,0,0,1,.435,1.09,1.651,1.651,0,0,1-.713,1.42A3.179,3.179,0,0,1,55.331-.618Z",
    transform: "translate(-466.319 -1577.004)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyordersNextLogo);
export default __webpack_public_path__ + "static/media/myorders-next-logo.f011a595030df7be28f85d194e524315.svg";
export { ForwardRef as ReactComponent };